import { useEffect, useMemo, useState } from 'react';
import Header from '../components/Header.jsx';
import GalleryGrid from '../components/GalleryGrid.jsx';
import LightboxModal from '../components/LightboxModal.jsx';
import { artworks as artworkData } from '../data/artworks.js';
import { useDeepLinkedArtwork } from '../hooks/useDeepLinkedArtwork.js';
import { useScrollRestoration } from '../hooks/useScrollRestoration.js';

export default function GalleryPage() {
  const artworks = useMemo(() => artworkData, []);
  const [activeIndex, setActiveIndex] = useState(null);
  const { deepLinkedSlug, setArtworkParam, clearArtworkParam } = useDeepLinkedArtwork();
  const { capture, restore } = useScrollRestoration();

  useEffect(() => {
    if (!deepLinkedSlug) return;
    const index = artworks.findIndex((artwork) => artwork.slug === deepLinkedSlug);
    if (index >= 0) {
      setActiveIndex(index);
    }
  }, [deepLinkedSlug, artworks]);

  useEffect(() => {
    if (activeIndex === null) return;
    const slug = artworks[activeIndex]?.slug;
    if (slug && slug !== deepLinkedSlug) {
      setArtworkParam(slug);
    }
  }, [activeIndex, artworks, deepLinkedSlug, setArtworkParam]);

  const handleOpen = (artwork, index, element) => {
    capture(element);
    setActiveIndex(index);
    setArtworkParam(artwork.slug);
  };

  const handleClose = () => {
    setActiveIndex(null);
    clearArtworkParam();
    restore();
  };

  const handlePrev = () => {
    setActiveIndex((prev) => {
      if (prev === null) return prev;
      return (prev - 1 + artworks.length) % artworks.length;
    });
  };

  const handleNext = () => {
    setActiveIndex((prev) => {
      if (prev === null) return prev;
      return (prev + 1) % artworks.length;
    });
  };

  return (
    <div className="page page--gallery">
      <Header />
      <main className="main-content">
        <GalleryGrid artworks={artworks} onOpen={handleOpen} />
      </main>
      <LightboxModal
        isOpen={activeIndex !== null}
        activeIndex={activeIndex}
        artworks={artworks}
        onClose={handleClose}
        onPrev={handlePrev}
        onNext={handleNext}
      />
    </div>
  );
}
